import {
  REGISTER_AREAS,
  REGISTER_USERS,
  REGISTER_AREAS_BY_USER,
  GET_USERS_LIST,
  GET_AREAS,
  GET_AREAS_BY_USER,
  SAVE_AREA_USER,
  DELETE_AREA,
  AREA_ERROR
} from "./actionTypes"


export const registerUsers = users => {
  return {
    type: REGISTER_USERS,
    payload: users,
  }
}

export const registerAreas = areas => {
  return {
    type: REGISTER_AREAS,
    payload: areas,
  }
}

export const registerAreasByUser = areasByUser => {
  return {
    type: REGISTER_AREAS_BY_USER,
    payload: areasByUser
  }
}
export const getAreas = areas => {
  return {
    type: GET_AREAS,
    payload: { areas }
  }
}

export const getUserList = users => {
  return {
    type: GET_USERS_LIST,
    payload: { users }
  }
}

export const getAreasByUser = id => {
  return {
    type: GET_AREAS_BY_USER,
    payload: { id }
  }
}

export const saveAreaByUser = (old, data) => {
  return {
    type: SAVE_AREA_USER,
    payload: { old, data }
  }
}

export const deleteArea = (old, data,username) => {
  return {
    type: DELETE_AREA,
    payload: { old, data,username }
  }
}
export const areaError = error => {
  return {
    type: AREA_ERROR,
    payload: error,
  }
}
